import logo from './logo.svg';

export const images = {
  logo,
};
